export default "__VITE_ASSET__76bb5f57__"